import React, { useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertDialog from "../components/alert.component";
import TestimonialForm from "./testimonial.form";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import { isEmpty } from "lodash";

import { Api } from "../utils/api";
import { useQuery } from "react-query";

const api = new Api();

const TestimonialEdit = (props) => {
  const { id } = props.match.params;
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const testimonialType = props.location.pathname.includes("professional")
    ? "professional"
    : "particular";

  const getTestimonial = async () => {
    const { data: testimonial } = await api.get(`/testimonials/${id}`);
    return testimonial;
  };

  const onDelete = async (testimonial) => {
    const res = await api.delete(`testimonials/${testimonial.id}`);
    if (res.status === 204) {
      props.history.push(`/testimonials/${testimonial.type}`);
    }
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    Object.keys(data).map((attr) => {
      if (attr == "file") {
        if (!isEmpty(data["file"])) {
          formData.append(`testimonial[${attr}]`, data[attr][0]);
        }
      } else {
        formData.append(`testimonial[${attr}]`, data[attr]);
      }
    });

    const res = await fetch(`${api.apiBase}/testimonials/${id}`, {
      method: "PATCH",
      body: formData,
    });

    if (res.status === 200) {
      setAlertMessage("Dados atualizados com sucesso");
      setAlertTitle("Sucesso");
    } else {
      setAlertMessage("Erro ao guardar dados do testemunho");
      setAlertTitle("Erro");
    }
    setShowAlert(true);
  };

  const { data, error, isError, isLoading } = useQuery(
    ["testimonials", id, showAlert],
    () => getTestimonial()
  );

  if (isLoading) {
    return <CircularProgress color="primary" />;
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <AlertDialog
        open={showAlert}
        handleClose={() => setShowAlert(false)}
        title={alertTitle}
        message={alertMessage}
      ></AlertDialog>
      <TestimonialForm
        testimonial={data}
        onSubmit={onSubmit}
        onDelete={onDelete}
      ></TestimonialForm>
      <Grid container spacing={4}>
        <Grid item xs={1}></Grid>
        <Grid item xs={6}>
          <Button href={`/testimonials/${testimonialType}`} variant="contained">
            Voltar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default TestimonialEdit;
